// this file is auto generated by ng g @mooxy/schematics:data-access
import {Injectable, Optional} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from "../../../../../api-endpoint/src/lib/api.config";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {ContractPartner} from "@kion/data-models";

interface IContractPartnerResponse {
  baseStores: ContractPartner[]
}

@Injectable()
export class ContractPartnersConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/networkpartners';


  constructor(private http: HttpClient, @Optional() apiConfig: ApiConfig) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  getAll(): Observable<ContractPartner[]> {

    return this.http.get<IContractPartnerResponse>(this.getManyUrl()).pipe(
      map(
        (response: IContractPartnerResponse) => this.transformFromApi(response.baseStores)
      ),
      catchError(error => throwError('Could not load Contract Partners.', error))
    )
  }

  setContractPartner(networkPartnerId: string, cartId: string) {
    return this.http.put(this.getSetContractPartnerUrl(cartId), {uid: networkPartnerId}).pipe(
      catchError(error => throwError('Could not update the network partner.', error))
    )
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  private transformFromApi = function (response: ContractPartner[]) {
    return response.map(entry => ({...entry, id: entry.uid}));
  };


  private getSetContractPartnerUrl(cartId: string) {
    const auth = window.localStorage.getItem('auth')
    return `${this._rootUrl}${this._baseSite}/users/anonymous/carts/${cartId}/networkpartner`;
  }
}
